import React, { useEffect } from 'react';

export function useOnClickOutside(
    ref: React.RefObject<HTMLElement> | null,
    handler: (event: MouseEvent | TouchEvent) => void
) {
    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            const target = event.target as HTMLElement | null;
            // Popovers/dropdowns rendered in a portal (outside the ref) opt out of
            // the outside-click via [data-outside-ignore] so they don't close the
            // surrounding modal.
            if (target?.closest?.('[data-outside-ignore]')) {
                return;
            }
            if (!ref?.current || ref?.current.contains(target as Node)) {
                return;
            }
            handler(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}
